import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { getContent } from '../../api';

export default function EmailValidation() {
  const [email, setEmail] = useState();
  const [state, setState] = useState('');
  const [error, setError] = useState(' ');
  const [logo, setLogo] = useState(null);
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    getContent()
      .then((res) => {
        setLogo(res.data.main[1].image);
      })
      .catch();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    const request = { email };
    axios.post(
      `${process.env.REACT_APP_API_URI}/api/request_password_recover`,
      request,
    )
      .then(() => setState('success'))
      .catch((err) => {
        setState('error');
        setError(err.response.data.message);
      });
    setState('success');
  };

  if (state === 'success') {
    return (
      <div className="container d-flex mt-5">
        <div className="mx-4 w-100">
          <div className="w-100">
            <div className="login-logo">
              <img src={`${process.env.REACT_APP_API_URI}/api/image/${logo}`} alt="" width="179" height="120" />
            </div>
            <h2 className="text-center title">Recuperar Password</h2>
            <p className="text-center text">
              Foi enviado um link para recuperação de palavra passe para
              {' '}
              <br />
              <span className="text" style={{ color: '#831140' }}>{email}</span>
            </p>
            <div className="text-center mt-5">
              <a href="/">
                <button type="button" className="green-button">HomePage</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login">
      <button type="button" className="go-back-button" onClick={() => { history.goBack(); }}>
        {t('goBack')}
      </button>
      <div className="d-flex flex-wrap vertical-align justify-content-center mb-5 mt-5">
        <div className="">
          <div className="login-input">
            <div className="login-logo">
              <img src={`${process.env.REACT_APP_API_URI}/api/image/${logo}`} alt="" width="179" height="120" />
            </div>
            <div className="d-flex flex-wrap vertical-align justify-content-center mt-5">
              <h1 className="my-auto font-weight-bold title-404 text-center title">Recuperar Password</h1>
            </div>
            <Form className="login-form" action="" method="post" onSubmit={submit}>
              <Form.Group>
                <Form.Label htmlFor="email">Insira o seu Email</Form.Label>
                <Form.Control
                  type="email"
                  name="EMAIL"
                  id="email"
                  required
                  className="form-control input-field"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              <div><small className="text-danger pre-wrap">{state === 'error' && error}</small></div>
              <Form.Group className="login-row">
                <input type="submit" className="login-button" value="Submeter" />
              </Form.Group>
            </Form>

          </div>
        </div>
      </div>
    </div>

  );
}
